import React from 'react';
import styles from './SelectionBar.module.css';

const SelectionBar = ({
  children,
  className,
  style,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) => (
  <div
    {...props}
    className={className ? `${styles.bar} ${className}` : styles.bar}
    style={{
      zIndex: 5,
      ...style,
    }}
  >
    {children}
  </div>
);

export default SelectionBar;
